import { render, staticRenderFns } from "./TicketPage.vue?vue&type=template&id=4170ff80&scoped=true&"
import script from "./TicketPage.vue?vue&type=script&lang=js&"
export * from "./TicketPage.vue?vue&type=script&lang=js&"
import style0 from "./TicketPage.vue?vue&type=style&index=0&id=4170ff80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4170ff80",
  null
  
)

export default component.exports